export const GET_PROJECTS_LIST = 'GET_PROJECTS_LIST';

export const getProjectList = projects => ({
  type: GET_PROJECTS_LIST,
  ...projects,
});
